import React from "react";
var __jsx = React.createElement;
import YTGInputField from './YTGInputField';
import YTGScoreField from './YTGScoreField';

var YTGField = function YTGField(_ref) {
  var formField = _ref.formField;
  return __jsx(React.Fragment, null, __jsx(YTGInputField, {
    formField: formField
  }), __jsx(YTGScoreField, {
    formField: formField
  }));
};

export default YTGField;